/* eslint-disable linebreak-style */
import React from 'react';
const DismembermentStepShared = () => (
  <ol>
    <li>
    Physician Attending statement
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
  </ol>
);

export default DismembermentStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/components/DismembermentStepShared.js